import type { OnboardingField } from '../constants/onboardingFields';

export const OnboardingStatus = {
	Draft: 'DRAFT',
	Subscribed: 'SUBSCRIBED',
	DetailsSubmitted: 'DETAILS_SUBMITTED',
	Complete: 'COMPLETE',
} as const;
export type OnboardingStatus = (typeof OnboardingStatus)[keyof typeof OnboardingStatus];

export interface OnboardingRecord {
	id: string;
	/** Firebase Auth UID — only present after provision step */
	userId?: string;
	email: string;
	dealershipName: string;
	dealerWebsiteUrl: string;
	status: OnboardingStatus;

	// Selected products
	productIds?: string[];

	// Billing linkage
	stripeCustomerId?: string;
	stripeSubscriptionId?: string;
	stripeSubscriptionStatus?: string;

	// Linkage to created resources
	servicesProviderId?: string;

	// Timestamps
	createdAt: number;
	updatedAt: number;
}

export interface Product {
	id: string;
	name: string;
	description: string;
	features: string[];
	priceMonthly: number;
	priceDisplay: string;
	icon: string;
	/** Fields required from the dealer during onboarding for this product */
	requiredFields: OnboardingField[];
	/** When true, the product card is non-selectable */
	disabled?: boolean;
	/** When true, a "Coming Soon" badge is shown and the card is disabled */
	comingSoon?: boolean;
}
